import { format } from 'date-fns';

export const dataFormatada = (data) => {
  if (data) {
    const dataHoraFormatada = new Date(data);

    return format(dataHoraFormatada, 'dd/MM/yyyy');
  }

  return 'N/I';
};

const dataFormatFilter = {
  install(Vue) {
    Vue.filter('dataFormatada', dataFormatada);
  },
};

// eslint-disable-next-line no-useless-escape
export const formatDataAlteracao = (data) => format(new Date(data), "'Em' dd/MM/yyyy 'às' HH:mm:ss");

export default dataFormatFilter;
